import { useQueries, useQuery } from 'react-query';
import { usePermissions } from 'react-admin';
import { getLegalConsent, getLegalConsents, getNotifications } from '~/api/solutions';
import { LegalConsentConfiguration } from '~/types/LegalConsent';

export const useGetNotifications = (solutionId: string, type: 'transaction' | 'profile') => {
  return useQuery(['notifications', solutionId], () => getNotifications(solutionId, type));
};

export const useGetSolutionLegalConsents = (solutionId?: string, enabled = true) => {
  const { permissions } = usePermissions();

  return useQuery(['solutionLegalConsents', solutionId], () => getLegalConsents(solutionId!), {
    enabled: enabled && !!solutionId && !!permissions?.includes('solution.legalConsent.view'),
  });
};

export const useGetSolutionLegalConsentsByIds = (
  solutionId?: string,
  ids: string[] = [],
  enabled = true
) => {
  const { permissions } = usePermissions();
  const canQuery = enabled && !!solutionId && !!permissions?.includes('solution.legalConsent.view');

  return useQueries(
    ids.map((id) => ({
      queryKey: ['solutionLegalConsent', solutionId, id],
      queryFn: () => getLegalConsent(solutionId!, id),
      enabled: canQuery,
    }))
  ) as { data?: LegalConsentConfiguration }[];
};
